import { Container, Form, FloatingLabel, Row, Col, Button, Spinner, Alert } from 'react-bootstrap'
import Card from '../components/Card'
import { useState, useEffect } from 'react'
import API from '../api/api'
export default function Suggestions(props) {


    const [comment, setComment] = useState('')
    const [loading, setLoading] = useState('')
    const [submitted, setSubmitted] = useState(false)

    const _submit = async (e) => {
        e.preventDefault()
        setSubmitted(false)
        setLoading(true)
        await API.createSuggestion(comment)
        setSubmitted(true)
        setLoading(false)
        setComment('')
    }

    useEffect(() => {
        document.title = 'ScamWall | Support'

    }, [])


    return (
        <Container fluid className='pt-4 ps-4 m-0 text-center'>
            <h1 >Have an Idea to Improve Our Service? Need Help?</h1>
            <p >Reach Out to Us!</p>
            <Row >
                <Col md={7} className='mx-auto'>
                    <Card>
                        <Form onSubmit={_submit}>
                            <Form.Group>
                                <Form.Label><b>Comment Card</b></Form.Label>
                                <Form.Control
                                    required
                                    value={comment}
                                    onChange={e => setComment(e.target.value)}
                                    as="textarea"
                                    placeholder="Leave a question or suggestion here"
                                    style={{ height: '100px' }}
                                />
                            </Form.Group>
                            {loading && <div className='text-center'><Spinner animation='border' className='my-3' /></div>}
                            {submitted && <Alert variant='success text-center my-2'>Successfully sent</Alert>}
                            <Button variant='primary' type='submit' className='mt-4' disabled={loading}>Submit</Button>
                        </Form>
                    </Card>

                </Col>
            </Row>


        </Container>
    )
}